/* eslint-disable no-nested-ternary */
import { Grid, IconButton, Menu, MenuItem, Paper } from '@material-ui/core';
import {
  ChevronLeft,
  Description,
  Group,
} from '@material-ui/icons';
import {
  getContractTypes,
  getInfosDashboard,
  getStudentOnTeam,
  getTeamById,
  getTeamInfoById,
  setTeamMemberAction,
} from '@webapps/business';
import {
  Button,
  Modal,
  ModalSideBar,
  PaginationNumbers,
  TextField,
  useAuth,
  useMutation,
  useQuery,
  useRouter,
  useToast,
} from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';

import MessageBox from 'components/MessageBox';
import ModalConfirm from 'components/ModalConfirm/ModalConfirm';
import ProfilSidebar from 'components/ProfilSidebar';
import ProfilName from 'components/ProfilSidebar/Components/ProfilName';
import { ROUTES_PATH } from 'config/constants';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';

import ActionTeam from '../Team/Components/ActionsTeam';
import CandidatsCard from './Components/CandidatsCard';
import TableActions from './Components/TableActions';
import Information from 'components/Icons/Information';
import KPITeam from './Components/KPITeam';
import CvTheque from 'components/Icons/CvTheque';
import KPIBusiness from 'pages/Business/AnnoncesCandidats/components/KPIBusiness';
import { useHistory } from 'react-router-dom';
import ModalFullScreen from 'components/ModalFullScreen/ModalFullScreen';
import PlanningManager from 'pages/school/ClassesPage/ClassesDetail/Components/PlanningManager';
import AbsenceDeclarationModal from 'components/AbsenceDeclarationModal';

const TeamDetail = () => {
  const {
    classes,
    css,
    global,
    cx,
    theme: { spacing },
  } = useStyles(styles);

  const { params, push } = useRouter();
  const { id: idParam } = params;
  const { idUser } = useAuth();
  const [page, setPage] = useState(1);
  const [keyword, setKeyword] = useState('');
  const [contractType, setContractType] = useState('');
  const [openMessageBox, setOpenMessageBox] = useState(false);
  const [candidatId, setCandidatId] = useState(0);
  const history = useHistory();

  const handleOpenMessageBox = () => {
    setOpenMessageBox(true);
  };
  const handleCloseMessageBox = () => {
    setOpenMessageBox(false);
  };

  const contactMember = (id) => {
    setCandidatId(id);
    handleOpenMessageBox();
  };

  const {
    // status: load,
    data: { content: infoMembers = [], totalElements } = {},
    refetch,
    // isFetching,
  } = useQuery(getStudentOnTeam, {
    key: ['teams', page + idParam + keyword + contractType],
    variables: {
      keyword,
      contractType,
      id: idParam,
      status: 'ENROLLED',
      page: page - 1,
      size: 10,
    },
    keepPreviousData: true,
    staleTime: 5000,
  });

  const { data: contractTypes = [] } = useQuery(getContractTypes, {
    key: 'contractTypes',
  });

  const handlePaginationChange = (newPage) => {
    setPage(newPage);
  };

  const [viewProfil, setViewProfil] = useState(false);
  const [viewPlanning, setViewPlanning] = useState(false);
  const [anchorVitrine, setAnchorVitrine] = useState(null);

  const openCandid = Boolean(anchorVitrine);

  const [student, setStudent] = useState('');
  const [currentRefetchAbsenceHours, setCurrentRefetchAbsenceHours] = useState(null);
  const [absenceModalOpen, setAbsenceModalOpen] = useState(false);
  const [classroomId, setClassroomId] = useState(null);
  const [isHavePlanning, setIsHavePlanning] = useState(false);
  const [defaultTabValue, setDefaultTabValue] = useState(null);

  const handleOpenViewProfil = () => {
    setViewProfil(true);
  };
  const handleCloseViewProfil = () => {
    setViewProfil(false);
  };

  const handleOpenPlanning = () => {
    setViewPlanning(true);
  };

  const handleClosePlanning = () => {
    setViewPlanning(false);
  };

  const viewCV = (student, classroomId, isHavePlanning) => {
    setStudent(student);
    setClassroomId(classroomId);
    setViewProfil(true);
    setDefaultTabValue("1");
    setIsHavePlanning(isHavePlanning);
  };

  const viewUserPlanning = (student, classroomId, isHavePlanning) => {
    setStudent(student);
    setClassroomId(classroomId);
    setViewProfil(true);
    setDefaultTabValue("4");
    setIsHavePlanning(isHavePlanning);
  };

  const searchKeyword = (e) => {
    setKeyword(e.target.value);
    setPage(1);
  };

  const searchContract = (e) => {
    if (e.target.value) {
      // eslint-disable-next-line no-unused-expressions
      e.target.value === 'all'
        ? setContractType('')
        : setContractType(e.target.value);
      setPage(1);
    }
  };

  const goToPreviousPage = () => {
    window.history.back();
  };

  const { addToast } = useToast();

  const {
    error: errorMemberTeamAction,
    isLoading: isLoadingMemberTeamAction,
    isSuccess: isSuccessMemberTeamAction,
    mutateAsync: mutateSetMemberTeam,
  } = useMutation(setTeamMemberAction);

  const deleteOnTeam = (id) => {
    mutateSetMemberTeam({
      id,
      action: 'exclude',
    });
  };

  useEffect(() => {
    if (errorMemberTeamAction) {
      addToast({
        status: 'error',
        message: 'Erreur',
      });
    }
    if (isSuccessMemberTeamAction) {
      addToast({
        status: 'success',
        message: 'Etudiant supprimé avec succès',
      });
      refetch();
      handleCloseViewConfirmDelete();
    }
  }, [isSuccessMemberTeamAction, errorMemberTeamAction]);

  const [selectedMember, setSelectedMember] = useState();
  const [viewConfirmDelete, setViewConfirmDelete] = useState(false);

  const handleOpenViewConfirmDelete = (id) => {
    setSelectedMember(id);
    setViewConfirmDelete(true);
  };

  const viewAbsence = (id, idClassroom, refetchAbsenceHours) => {
    setStudent(id);
    setClassroomId(idClassroom)

    setCurrentRefetchAbsenceHours(() => refetchAbsenceHours); 

    setAbsenceModalOpen(true);
  };

  const handleCloseViewConfirmDelete = () => {
    setViewConfirmDelete(false);
  };

  const goToStudentClassHistorique = () => {
    push(ROUTES_PATH.BUSINESS_STUDENT_HISTORIQUE, { params: { id: idParam } });
  };

  const handleClick = (event) => {
    setAnchorVitrine(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorVitrine(null);
  };

  const { data: team = {} } = useQuery(getTeamInfoById, {
    key: ['team', idParam],
    variables: { id: idParam },
  });

  const {
    data: dashboardInfo = {},
    refetch: refetchDashboardInfo,
  } = useQuery(getInfosDashboard, {
    key: 'infoDashboardBusiness',
    variables: { id: idUser },
  });

  return (
    <div className={classes.container}>
      <Button
        className={classes.returnButtonTop}
        onClick={goToPreviousPage}
        startIcon={<ChevronLeft />}
      >
        Retour
      </Button>

      <KPIBusiness data={[
        { label: 'Nom de l\'équipe', value: team?.label, icon: Group },
        { label: 'Contrats de stage', value: dashboardInfo?.teamStats?.internshipStudents, icon: Description },
        { label: 'Contrats d\'alternance', value: dashboardInfo?.teamStats?.alternanceStudents, icon: Description },
        { label: 'Contrats à signer', value: dashboardInfo?.contractStats?.contractToSign, icon: CvTheque },
      ]} />
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <div className={classes.containerSearch}>
            <div
              className={css({
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                '@media (max-width:768px)': {
                  // justifyContent: 'flex-end' 
                },
              })}
            >
              <div className={classes.leftFilterContainer}>
                <Button
                  className={classes.returnButton}
                  onClick={goToPreviousPage}
                  startIcon={<ChevronLeft />}
                >
                  Retour
                </Button>
                {/* </Grid> */}
                {/* <Grid xs={12} sm={4}> */}
                <div
                  className={classes.leftFilterInput}
                >
                  <TextField
                    fullWidth
                    label="Nom et prénom"
                    onChange={(e) => searchKeyword(e)}
                    borderRadius={30}
                  />
                </div>

                <div className={classes.leftFilterInput}>
                  <TextField
                    fullWidth
                    label="Type de contrat"
                    name="offer"
                    onChange={(e) => searchContract(e)}
                    select
                    borderRadius={30}
                  >
                    <MenuItem value="all">Tous les contrats</MenuItem>
                    {contractTypes.map(({ id, label }, index) => (
                      <MenuItem key={index} value={id}>
                        {label}
                      </MenuItem>
                    ))}
                  </TextField>
                </div>

              </div>
              <div className={classes.rightFilterContainer}>
                <ActionTeam
                  from="item"
                  id={idParam}
                  nbrStudent={totalElements}
                  refetch={() => { }}
                />
              </div>
            </div>
            <Grid
              className={css({ background: 'white', marginTop: spacing(2.5) })}
              item
              xs={12}
            >
              {!infoMembers?.length ? (
                <Grid className={classes.noResultContainer} container>
                  <Grid item className={classes.container2}>
                    <h1 className={cx(global.title, classes.h1)}> Commencez à inviter des apprenants </h1>
                    <div className={classes.containerInfo}>
                      <div className={classes.info}>
                        <Button
                          color="primary"
                          variant="contained"
                          fullWidth
                          onClick={() => history.push(ROUTES_PATH.BUSINESS_TEAMS, {
                            openInviteStudents: true,
                          })}
                          disableElevation
                          className={classes.btn}
                        >
                          Inviter un apprenant
                        </Button>
                        <div>
                          <p className={cx(global.infoText, classes.stepStyles)}> 1. Recherchez un apprenant pour votre formation. </p>
                          <p className={cx(global.infoText, classes.stepStyles)}> 2. Ajouter le à votre classe. </p>
                          <p className={cx(global.infoText, classes.stepStyles)} style={{ marginBottom: '20px' }}> 3. Permettez aux entreprises paternaire de voir vos apprenants. </p>
                        </div>
                      </div>
                    </div>
                  </Grid>
                </Grid>
              ) : (
                <Grid
                  container
                  style={{
                    backgroundColor: '#F3F7FF',
                    borderRadius: 10,
                    padding: spacing(0, 0, 2.5, 2.5),
                    marginBottom: page > 1 ? spacing(2.5) : spacing(0),
                  }}
                >
                  {infoMembers?.map((item, index) => (
                    <CandidatsCard
                      item={item}
                      refetch={refetch}
                      contactMember={() => contactMember(item?.student?.id)}
                      deleteMember={() => handleOpenViewConfirmDelete(item?.id)}
                      addAbsence={(id, classroomId, refetchAbsenceHours) => viewAbsence(id, item?.student?.classroom?.id, refetchAbsenceHours)}
                      id={item?.student?.id}
                      classId={item?.student?.classroom?.id}
                      classroomId={item?.student?.classroom?.id}
                      viewMember={() => viewCV(item?.student, item?.student?.classroom?.id, item?.student?.classroom?.planning != null)}
                      viewPlanning={() => viewUserPlanning(item?.student, item?.student?.classroom?.id, item?.student?.classroom?.planning != null)}
                      hideInfos={true}
                      hideAbsence={item?.student?.classroom?.planning == null} // Si il n'a pas de planning
                    />
                  ))}
                </Grid>
              )}
            </Grid>
          </div>
        </Grid>
      </Grid>
      <PaginationNumbers
        onChange={handlePaginationChange}
        page={page}
        pageCount={10}
        totalCount={totalElements}
      />
      <ModalSideBar
        handleClose={handleCloseViewProfil}
        open={viewProfil}
        title={<ProfilName userId={student?.id} />}
        button={
          <>
          {isHavePlanning && <Button
            className={css({
              color: '#0060F9',
              // width: '100%',
              backgroundColor: '#F3F7FF',
              border: '1px solid #0060F9',
              fontWeight: 500,
              display: 'flex',
              justifyContent: 'space-between',
              marginRight: '20px',
              '&:hover': {
                border: '1px solid #0060F9', backgroundColor: '#0060F9',
                color: "white",
              },
            })}
            color="primary"
            variant="outlined"
            onClick={() => setAbsenceModalOpen(true)}
          >
            Déclarer une absence
          </Button>}
          </>
        }
        width="700px"
      >
        <ProfilSidebar id={student?.id} typeOrganism="business" classroomId={classroomId} defaultTabValue={defaultTabValue} displayPlanning={true} />
      </ModalSideBar>
      <AbsenceDeclarationModal
        open={absenceModalOpen}
        student={student}
        classroomId={classroomId}
        onClose={() => setAbsenceModalOpen(false)}
        onConfirm={() => {
          if (currentRefetchAbsenceHours) {
            currentRefetchAbsenceHours(); // Re-fetch uniquement pour l'utilisateur ciblé
          }
        }}
      />
      <ModalFullScreen
        handleClose={handleClosePlanning}
        open={viewPlanning}
        title="Planning"
      >
        <PlanningManager
          classroomId={classroomId}
          from="business"
          studentId={student?.id}
          isClassAuthorized={false}
          teamId={idParam}
        />
      </ModalFullScreen>

      <Modal
        onCancel={handleCloseMessageBox}
        open={openMessageBox}
        // subTitle="Envoyez un message aux candidats et gardez contact dans votre
        // messagerie"
        title="Envoyer un message"
        withStep={false}
      >
        <div className={css({ display: 'flex', flexDirection: 'row' })}>
          <span>
            <Information className={css({ color: '#0060F9', height: 20, width: 20, marginRight: 10 })} />
          </span>
          <div className={css({ fontSize: 14, color: 'rgba(0, 0, 0, 0.87)' })}>
            Envoyez un message aux candidats et gardez contact dans votre
            messagerie
          </div>
        </div>
        <MessageBox id={candidatId} onCancel={handleCloseMessageBox}/>
      </Modal>
      <ModalConfirm
        cancelBtnTitle="Non"
        confirmBtnTitle="Oui"
        confirmFunction={() => deleteOnTeam(selectedMember)}
        isLoading={isLoadingMemberTeamAction}
        onClose={handleCloseViewConfirmDelete}
        open={viewConfirmDelete}
        title="Supprimer de l'équipe"
      >
        Êtes-vous sûr de vouloir Supprimer l'étudiant de l'équipe
      </ModalConfirm>
    </div>
  );
};

const styles = ({ spacing }) => ({
  container: {
    height: '100%',
    padding: '50px',
    '@media only screen and (max-width:1543px)': { padding: '42px' },
    '@media only screen and (max-width:1440px)': { padding: '34px' },
    lineHeight: '100%',
    '@media (max-width:768px)': { padding: spacing(3, 2, 2, 2) },
  },
  containerSearch: {
    background: 'white',
    padding: spacing(2.5),
    borderRadius: 10,
    '@media only screen and (max-width:768px)': {
      marginTop: spacing(3),
      paddingTop: spacing(2.5),
    },
  },
  leftFilterContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    '@media (max-width:768px)': {
      flexDirection: 'column',
      width: '100%',
    },
  },
  leftFilterInput: {
    width: '100%',
    minWidth: '200px',
    width: '20vw',
    '@media (max-width:768px)': { width: '100%' },
    // backgroundColor: 'red !important',
  },
  rightFilterContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  title: {
    margin: 0,
    flex: 1,
  },
  searchContainer: {
    marginTop: spacing(2.5),
  },
  button: {
    height: '42px',
  },
  buttonOutlined: {
    border: '1px solid #0060F9',
    '&:hover': { border: '1px solid #0060F9', backgroundColor: '#C0D8FF' },
    height: '42px',
  },
  returnButton: {
    color: '#5A6DA1',
    '@media only screen and (max-width:1920px)': { fontSize: '13.500px' }, '@media only screen and (max-width:1600px)': { fontSize: '13.5000px' },
    border: '1px solid #C0D9FF',
    backgroundColor: 'white',
    borderRadius: '20px',
    padding: '5px 20px',
    fontWeight: 600,
    '@media (max-width:768px)': { display: 'none' },
  },
  returnButtonTop: {
    display: 'none',
    color: '#5A6DA1',
    '@media only screen and (max-width:1920px)': { fontSize: '13.500px' }, '@media only screen and (max-width:1600px)': { fontSize: '13.5000px' },
    border: '1px solid #C0D9FF',
    backgroundColor: 'white',
    borderRadius: '20px',
    padding: '5px 20px',
    fontWeight: 600,
    '@media (max-width:768px)': { display: 'flex' },
    marginBottom: spacing(2.5),
  },
  teamsDiv: {
    marginTop: spacing(1),
    marginBottom: spacing(1),
    backgroundColor: '#F3F7FF',
    borderRadius: 20,
    width: '100%',
  },
  paper: {
    padding: spacing(2.5),
    borderRadius: 10,
  },
  teamsContainer: {
    background: 'white',
    padding: spacing(4),
    borderRadius: 10,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    '@media (max-width:768px)': { padding: spacing(2) },
  },
  noResultContainer: {
    backgroundColor: '#F3F7FF',
    borderRadius: 20,
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: 'calc(100vh - 75px - 298px)',
    padding: spacing(2.5),
    '@media (max-width:768px)': {
      margin: spacing(0),
    },
  },
  container2: {
    backgroundColor: '#FFFFFF',
    borderRadius: 12,
    padding: '30.0px',
    '@media screen and (max-width: 768px)': {
      padding: '20px',
    },
  },
  info: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    justifyContent: 'center',
    '@media screen and (max-width: 768px)': {
      flexDirection: 'column-reverse',
    }
  },
  stepStyles: {
    textAlign: 'center',
    margin: '10px 0 0 0',
    '@media screen and (max-width: 768px)': {
      margin: '0 0 10px 0',
    },
  },
  h1: {
    textAlign: 'center',
    margin: '0px 0px 30px 0px',
  },
});

export default TeamDetail;
